import { useAuthStore } from '@sentinel/web-core';
import { RouterProvider } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { BootScreen } from '@/shell/BootScreen';
import { router } from './router';
import { Providers } from './providers';

/** Application root: restores the session from the refresh cookie, then mounts the router. */
export function App() {
  const [ready, setReady] = useState(false);
  const bootstrap = useAuthStore((s) => s.bootstrap);

  useEffect(() => {
    void bootstrap().finally(() => setReady(true));
  }, [bootstrap]);

  return <Providers>{ready ? <RouterProvider router={router} /> : <BootScreen />}</Providers>;
}
